// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"282e6be3","453":"bdfc3c16","455":"919f9463","857":"bca234ed","947":"fb76fe4e","977":"80a48344"}[chunkId] + ".chunk.js";
};